import {
  put, call, all, takeLatest,
} from 'redux-saga/effects';
import { notification } from 'antd';
import { setCoatingReports, setCoatingReportFailure } from '../state/action/coatingLogAction';
import { GET_COATING_REPORTS } from '../state/types';
import fetch from '../services/fetch';
import { BASE_URL } from '../config';

function* getReports({ reportType }) {
  let status = 0;
  try {
    const res = yield fetch(`${BASE_URL}/reports?type=${reportType}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    });
    if (res.status === 403) {
      status = res.status;
      throw new Error('Unauthorized');
    }
    const response = yield res.json();
    yield put(setCoatingReports({ response }));
  } catch (error) {
    yield put(setCoatingReportFailure());
    if (status !== 403) {
      notification.error({
        message: 'There was a problem fetching the report details.',
        description: `${error}`,
      });
    }
  }
}

function* coatingLogWatcher() {
  yield takeLatest(GET_COATING_REPORTS, getReports);
}

function* coatingLogSagas() {
  yield all([
    call(coatingLogWatcher),
  ]);
}

export default coatingLogSagas;
